(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-cinta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const boton = event.target instanceof Element ? event.target.closest('.mb-cinta__pausa') : null;
    if (!boton) return;

    const pausada = boton.closest('.mb-cinta')?.classList.toggle('mb-cinta--pausada');
    boton.setAttribute('aria-pressed', String(Boolean(pausada)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-pinatas"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (evento) {
    var enlace = evento.target.closest ? evento.target.closest('[data-mb-pinata-quiero]') : null;
    if (!enlace) return;
    var campo = document.querySelector('[data-mb-pinata-modelo]');
    if (!campo) return;
    campo.value = enlace.getAttribute('data-mb-pinata-quiero') || '';
    campo.dispatchEvent(new Event('input', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-presupuesto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const estado = document.querySelector('[data-mb-presupuesto-estado]');
    if (estado) {
      estado.scrollIntoView({ block: 'center' });
      estado.focus({ preventScroll: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-recomendados"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mb-recomendados')) {
    class MbRecomendados extends HTMLElement {
      connectedCallback() {
        if (this.dataset.url) this.cargar();
      }

      async cargar() {
        try {
          const respuesta = await fetch(this.dataset.url);
          if (!respuesta.ok) return;
          const documento = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
          const lista = documento.querySelector('mb-recomendados [data-fila="parecido"] .mb-recomendados__lista');
          const destino = this.querySelector('[data-fila="parecido"] .mb-recomendados__lista');
          if (!lista || !destino || !lista.children.length) return;
          destino.innerHTML = lista.innerHTML;
          this.querySelector('[data-fila="parecido"]').hidden = false;
          this.hidden = false;
        } catch (error) {
          /* sin recomendaciones de Shopify: se queda lo propio */
        }
      }
    }
    customElements.define('mb-recomendados', MbRecomendados);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-tiktok"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mb-tiktok-tarjeta')) {
    /* Fachada: el <video> solo se crea al pulsar (la plantilla no carga nada). Sin sonido y con controles. */
    class MbTiktokTarjeta extends HTMLElement {
      connectedCallback() {
        const boton = this.querySelector('button[data-reproducir]');
        if (boton) boton.addEventListener('click', () => this.reproducir(boton));
      }

      reproducir(boton) {
        const plantilla = this.querySelector('template[data-video]');
        if (!plantilla) return;

        document.querySelectorAll('mb-tiktok-tarjeta video').forEach((otro) => otro.pause());

        const video = plantilla.content.querySelector('video').cloneNode(true);
        video.muted = true;
        boton.replaceWith(video);
        video.play().catch(() => {});
        video.focus({ preventScroll: true });
      }
    }

    customElements.define('mb-tiktok-tarjeta', MbTiktokTarjeta);
  }

  } catch(e) { console.error(e); }
})();
})();
